import React from 'react';
import { CheckCircle2Icon, BookOpenIcon, MonitorSmartphoneIcon, ClockIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
export function ProductSection() {
  const deliverables = [{
    icon: <BookOpenIcon className="h-6 w-6 text-brand-400" data-id="element-227" />,
    title: 'El Manual "Código de Micro-Señales"',
    desc: 'Ebook PDF de implementación rápida.'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6 text-brand-400" data-id="element-228" />,
    title: 'El Protocolo de las 7 Micro-expresiones Universales',
    desc: 'Identifica las emociones base.'
  }, {
    icon: <MonitorSmartphoneIcon className="h-6 w-6 text-brand-400" data-id="element-229" />,
    title: 'Guía de Decodificación Digital',
    desc: 'Cómo leer mentiras en Zoom y WhatsApp.'
  }, {
    icon: <ClockIcon className="h-6 w-6 text-brand-400" data-id="element-230" />,
    title: 'La Regla de los 3 Segundos',
    desc: 'Para detectar la falta de sincronía.'
  }, {
    icon: <FileTextIcon className="h-6 w-6 text-brand-400" data-id="element-231" />,
    title: 'Hoja de Campo "Alerta Roja"',
    desc: 'Herramienta práctica para llevar en tu celular.'
  }];
  return <section className="py-16 md:py-24 bg-slate-900 border-t border-slate-800" data-id="element-232">
      <div className="max-w-6xl mx-auto px-5 md:px-8" data-id="element-233">
        <div className="text-center mb-16" data-id="element-234">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-235">
            Lo que obtienes hoy
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-236">
            Un arsenal táctico completo diseñado para darte una ventaja injusta
            en cualquier interacción humana.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-237">
          <div className="order-2 md:order-1 space-y-6" data-id="element-238">
            {deliverables.map((item, idx) => <div key={idx} className="flex items-start bg-slate-800/40 p-5 rounded-xl border border-slate-700/50 hover:border-brand-500/30 transition-colors" data-id="element-239">
                <div className="bg-slate-900 p-3 rounded-lg mr-4 border border-slate-700" data-id="element-240">
                  {item.icon}
                </div>
                <div data-id="element-241">
                  <h3 className="text-lg font-bold text-slate-200" data-id="element-242">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm mt-1" data-id="element-243">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="order-1 md:order-2" data-id="element-244">
            <div className="relative max-w-md mx-auto" data-id="element-245">
              <div className="absolute -inset-4 bg-brand-500/10 rounded-3xl blur-2xl pointer-events-none" data-id="element-246"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6LPjQWAuopxkSqPGhWYyq4/A_high-end_iPad_202604241743.jpg" alt="Código de Micro-Señales - eBook" className="relative rounded-2xl shadow-2xl w-full object-cover border border-slate-700/50" data-id="element-247" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}